import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import n4Logo from '@/assets/n4-logo.webp';
import { supporters } from '@/data/mockData';

export function Footer() {
  return (
    <footer className="border-t border-navy/10 bg-cream text-foreground">
      <div className="container py-12">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* About Section */}
          <div>
            <div className="mb-4">
              <img 
                src={n4Logo} 
                alt="N4 Research Group" 
                className="h-24 w-auto"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 font-heading font-semibold text-navy">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/#research-areas"
                  className="text-muted-foreground hover:text-secondary transition-colors"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById('research-areas');
                    if (el) {
                      el.scrollIntoView({ behavior: 'smooth' });
                    } else {
                      window.location.href = '/#research-areas';
                    }
                  }}
                >
                  Research Areas
                </Link>
              </li>
              <li>
                <Link to="/publications" className="text-muted-foreground hover:text-secondary transition-colors">
                  Publications
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-muted-foreground hover:text-secondary transition-colors">
                  News & Updates
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-secondary transition-colors">
                  Our Team
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="mb-4 font-heading font-semibold text-navy">Contact</h3>
            <p className="mb-2 font-medium text-navy">Magnus Domellöf</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-secondary" />
                <a 
                  href="tel:+46706717963" 
                  className="text-muted-foreground hover:text-secondary transition-colors"
                >
                  +46 70 671 79 63
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-secondary" />
                <a 
                  href="mailto:magnus.domellof@umu.se" 
                  className="text-muted-foreground hover:text-secondary transition-colors"
                >
                  magnus.domellof@umu.se
                </a>
              </li>
            </ul>
          </div>

          {/* Supporters */}
          <div>
            <h3 className="mb-4 font-heading font-semibold text-navy">Our Supporters</h3>
            <div className="grid grid-cols-2 gap-3">
              {supporters.map((supporter) => (
                <a
                  key={supporter.name}
                  href={supporter.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-16 items-center justify-center hover:opacity-80 transition-opacity"
                >
                  <img
                    src={supporter.logo}
                    alt={supporter.name}
                    className="max-h-14 max-w-[110px] w-auto h-auto object-contain"
                    width={110}
                    height={56}
                    loading="lazy"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 border-t border-navy/10 pt-8 text-sm text-center">
          <p className="text-muted-foreground">
            © {new Date().getFullYear()} N4 Research Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
